import Icon from "@ant-design/icons";

const CookerHobSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M215 4511 c-92 -23 -175 -99 -200 -185 -23 -75 -23 -3457 0 -3532 19
   -64 73 -127 139 -162 49 -26 56 -27 214 -27 160 0 164 1 183 24 25 30 24 62
   -2 95 -20 26 -22 26 -155 26 -154 0 -192 11 -224 62 -20 33 -20 45 -20 1748 0
   1703 0 1715 20 1748 41 66 -103 62 2004 62 1845 0 1915 1 1937 18 33 27 30 78
   -5 109 l-27 23 -1917 -1 c-1054 -1 -1930 -4 -1947 -8z"
      />
      <path
        d="M4367 4500 c-34 -27 -37 -80 -7 -110 19 -19 33 -20 260 -20 269 0
   295 -5 330 -62 20 -33 20 -45 20 -1748 0 -1703 0 -1715 -20 -1748 -41 -67 114
   -62 -2114 -62 l-2025 0 -20 -26 c-26 -33 -27 -65 -2 -95 l19 -24 2054 0 2053
   0 51 27 c66 35 120 98 139 162 23 75 23 3457 0 3532 -19 64 -73 127 -139 162
   l-51 27 -260 3 c-254 3 -261 3 -288 -18z"
      />
      <path
        d="M1340 4112 c-18 -15 -23 -31 -28 -90 l-5 -72 -36 -6 c-20 -3 -62 -12
   -95 -20 -330 -80 -591 -363 -647 -703 l-12 -71 -66 0 c-85 0 -111 -16 -111
   -69 0 -56 26 -75 110 -79 l69 -4 6 -42 c44 -287 219 -528 475 -656 85 -43 149
   -64 237 -80 l71 -13 4 -68 c4 -80 27 -112 77 -112 52 0 70 26 73 106 l3 70
   105 23 c352 78 619 357 681 710 l11 62 68 4 c82 4 110 24 110 75 0 54 -28 73
   -109 73 l-69 0 -11 68 c-62 367 -336 646 -705 718 l-86 17 0 69 c0 55 -4 72
   -20 88 -25 25 -71 26 -100 2z m-32 -438 l-3 -126 -55 -17 c-79 -25 -139 -63
   -202 -129 -62 -64 -88 -110 -113 -195 l-16 -57 -126 0 -125 0 7 43 c29 180
   152 375 302 478 87 60 228 115 326 128 4 1 6 -56 5 -125z m276 100 c76 -18
   199 -83 265 -139 137 -117 227 -274 256 -447 l6 -38 -125 0 -125 0 -17 61
   c-42 148 -180 285 -324 322 l-55 14 -3 114 c-1 62 0 119 2 126 6 14 9 14 120
   -13z m-273 -470 c4 -79 6 -87 32 -110 34 -29 56 -30 91 -3 25 19 26 25 26 110
   0 101 3 103 70 69 58 -30 108 -77 141 -134 47 -82 44 -86 -59 -86 -96 0 -114
   -8 -127 -61 -5 -20 0 -33 18 -55 24 -27 31 -29 111 -33 47 -1 86 -7 86 -12 0
   -5 -11 -31 -24 -57 -28 -55 -102 -127 -151 -148 -63 -26 -65 -24 -65 73 0 102
   -12 123 -70 123 -58 0 -74 -26 -79 -126 -2 -51 -7 -84 -14 -84 -66 0 -217 152
   -217 219 0 5 38 11 85 12 97 5 128 24 128 78 0 57 -25 71 -125 71 -72 0 -88 3
   -88 15 0 29 48 110 87 146 37 36 106 78 129 79 8 0 13 -30 15 -86z m-380 -346
   c41 -155 182 -296 337 -337 l42 -12 0 -125 0 -125 -37 7 c-76 13 -190 54 -253
   91 -82 48 -204 170 -253 254 -36 62 -78 175 -91 252 l-7 37 125 0 125 0 12
   -42z m1172 5 c-28 -191 -171 -402 -339 -501 -71 -42 -187 -85 -261 -97 l-43
   -7 0 125 0 125 48 12 c146 37 283 163 327 304 9 28 18 57 20 64 3 9 38 12 129
   12 l125 0 -6 -37z"
      />
      <path
        d="M3680 4110 c-16 -16 -20 -33 -20 -89 l0 -69 -65 -11 c-379 -66 -658
   -343 -725 -719 l-13 -72 -69 0 c-80 0 -108 -19 -108 -73 0 -51 28 -71 110 -75
   l68 -4 12 -67 c61 -349 327 -626 681 -705 l104 -23 3 -70 c3 -80 21 -106 73
   -106 50 0 73 32 77 111 l4 68 83 16 c362 70 643 365 700 734 l6 42 69 4 c84 4
   110 23 110 79 0 53 -26 69 -111 69 l-67 0 -7 48 c-30 212 -150 424 -312 555
   -119 96 -242 153 -391 183 -41 8 -75 14 -77 14 -1 0 -5 32 -7 72 -5 59 -10 75
   -28 90 -29 24 -75 23 -100 -2z m-25 -440 l0 -123 -55 -14 c-145 -37 -282 -174
   -324 -322 l-17 -61 -125 0 -125 0 6 38 c38 223 173 415 372 524 81 45 225 91
   258 84 6 -2 10 -52 10 -126z m267 104 c63 -15 159 -60 226 -106 146 -100 268
   -296 297 -475 l7 -43 -125 0 -126 0 -16 57 c-24 83 -51 130 -107 189 -63 66
   -131 111 -206 134 l-57 18 -3 126 -3 127 28 -7 c15 -3 54 -12 85 -20z m-262
   -473 c0 -85 1 -91 26 -110 35 -27 57 -26 91 3 26 23 28 31 32 110 1 47 7 86
   12 86 20 0 92 -43 130 -77 40 -36 89 -118 89 -148 0 -12 -16 -15 -88 -15 -100
   0 -125 -14 -125 -71 0 -54 31 -73 128 -78 47 -1 85 -7 85 -12 0 -67 -151 -219
   -217 -219 -7 0 -12 33 -14 84 -5 99 -21 126 -77 126 -60 0 -72 -20 -72 -122 0
   -98 -2 -100 -65 -74 -49 21 -123 93 -151 148 -13 26 -24 52 -24 57 0 5 39 11
   86 12 80 4 87 6 111 33 18 22 23 35 18 55 -13 53 -31 61 -127 61 -100 0 -102
   3 -68 70 30 58 77 108 134 141 82 47 86 44 86 -60z m-380 -363 c47 -153 180
   -280 333 -318 l47 -12 0 -125 0 -125 -42 7 c-219 37 -408 169 -521 365 -29 50
   -72 174 -80 233 l-6 38 126 -3 125 -3 18 -57z m1164 25 c-11 -67 -61 -202 -95
   -260 -44 -73 -169 -198 -243 -242 -64 -38 -189 -85 -253 -95 l-43 -6 0 124 0
   125 43 12 c69 18 158 71 213 126 53 52 124 177 124 218 0 12 3 25 7 28 3 4 62
   7 130 7 l124 0 -7 -37z"
      />
      <path
        d="M1667 1778 c-19 -15 -37 -59 -37 -91 0 -17 -13 -27 -58 -47 -68 -29
   -139 -97 -172 -165 -21 -42 -25 -65 -25 -145 0 -113 21 -167 95 -240 73 -74
   127 -95 240 -95 78 0 103 4 141 23 70 34 122 84 160 154 32 59 34 69 34 158 0
   89 -2 99 -34 158 -41 76 -84 115 -168 154 -62 29 -63 31 -63 69 0 65 -64 103
   -113 67z m-37 -448 c0 -93 -3 -170 -6 -170 -19 0 -65 46 -83 83 -25 51 -27
   113 -6 163 14 35 69 94 86 94 5 0 9 -76 9 -170z m210 138 c63 -62 77 -146 39
   -225 -20 -41 -64 -83 -88 -83 -8 0 -11 53 -11 170 0 189 2 194 60 138z"
      />
      <path
        d="M2511 1771 c-11 -11 -23 -39 -26 -63 -6 -40 -10 -44 -60 -66 -75 -33
   -126 -80 -166 -154 -32 -59 -34 -69 -34 -158 0 -113 22 -167 95 -240 73 -74
   127 -95 240 -95 115 0 166 20 238 92 75 76 97 129 97 243 0 89 -2 99 -34 158
   -40 74 -91 121 -166 154 -50 22 -54 26 -60 66 -8 53 -35 82 -75 82 -16 0 -39
   -9 -49 -19z m-31 -441 c0 -93 -3 -170 -6 -170 -19 0 -65 46 -83 83 -25 51 -27
   113 -6 163 14 35 69 94 86 94 5 0 9 -76 9 -170z m200 150 c38 -27 70 -96 70
   -150 0 -54 -32 -123 -70 -150 -15 -11 -31 -20 -34 -20 -3 0 -6 77 -6 170 0 94
   3 170 6 170 3 0 19 -9 34 -20z"
      />
      <path
        d="M3360 1770 c-13 -13 -20 -33 -20 -59 0 -38 -2 -40 -57 -66 -82 -37
   -135 -85 -174 -157 -32 -59 -34 -69 -34 -158 0 -113 22 -167 95 -240 73 -74
   127 -95 240 -95 84 0 102 3 152 28 64 31 125 95 160 165 19 39 23 63 23 142 0
   80 -4 103 -25 145 -33 68 -104 136 -172 165 -44 19 -58 30 -58 46 0 35 -21 84
   -40 94 -30 16 -68 12 -90 -10z m-20 -440 c0 -117 -3 -170 -11 -170 -24 0 -68
   42 -88 83 -38 79 -22 170 40 228 57 53 59 48 59 -141z m190 150 c38 -27 70
   -96 70 -150 0 -54 -32 -123 -70 -150 -15 -11 -31 -20 -34 -20 -3 0 -6 77 -6
   170 0 94 3 170 6 170 3 0 19 -9 34 -20z"
      />
    </g>
  </svg>
);

const CookerHobIcon = (props) => <Icon component={CookerHobSvg} {...props} />;

export default CookerHobIcon;
